import { Button, Stack } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Table1 from "../../../components/Table/Table1";
import { Box } from "@mui/system";
import IMDashboard from "../Component/IMDashboard";
import boxStyles from "../../../styles/boxStyles";
import LoadingSpinner from "../../../components/LoadingSpinner";
import ApiService from "../../../services/ApiService";
import { useAuth } from "oidc-react";

const IMReviewVpAsset = () => {
  const { userData } = useAuth();
  const [dataRegion, setDataRegion] = useState([]);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataTahun, setDataTahun] = useState([]);

  useEffect(() => {
    getData();
    getDataRegion();
    getDataLokasi();
    getDataTahun();
    // eslint-disable-next-line
  }, []);

  const getDataRegion = () => {
    ApiService.getMsRegional().then((res) => {
      var result = res.data.payload;
      setDataRegion(result);
    });
  };
  const getDataLokasi = () => {
    ApiService.getMsLokasi().then((res) => {
      var result = res.data.payload;
      setDataLokasi(result);
    });
  };
  const getDataTahun = () => {
    ApiService.getMsTahun().then((res) => {
      var result = res.data.payload;
      setDataTahun(result);
    });
  };

  const [data, setData] = useState([]);
  const history = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const getData = () => {
    setIsLoading(true);
    const data1 = [];
    var options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const tgl = new Date().toLocaleDateString("en-US", options);

    for (var i = 0; i < 2; i++) {
      var dummy = "Dummy " + (i + 1);
      // var angka = 1000;
      data1.push({
        id: i,
        noLap: dummy,
        judul: dummy,
        reportDate: tgl,
        type: dummy,
        investigation: dummy,
        status: dummy,
      });
    }

    if (data1 != null) {
      setData(data1);
      setIsLoading(false);
    } else {
      setErrorMessage("Unable to fetch data list");
      setIsLoading(false);
    }
  };

  const Review = (id) => {
    // alert(id);
    history("/hsse/incident/reviewlokasi/" + id);
  };

  const columns = useMemo(
    () => [
      {
        Header: "VP Asset Management Reviewer List",
        columns: [
          {
            Header: "No Laporan",
            accessor: "noLap",
          },
          {
            Header: "Judul",
            accessor: "judul",
          },
          {
            Header: "Date Reported",
            accessor: "reportDate",
          },
          {
            Header: "Status",
            accessor: "status",
          },
          {
            Header: "",
            accessor: "id",
            Cell: (props) => {
              return (
                <Stack spacing={2} direction="row">
                  <Button
                    variant="contained"
                    sx={{ width: "150px" }}
                    onClick={() => Review(props.value)}
                  >
                    Review
                  </Button>
                </Stack>
              );
            },
          },
        ],
      },
    ],
    // eslint-disable-next-line
    []
  );

  const mainContainer = <Table1 columns={columns} data={data} />;

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 0,
      }}
    >
      <p>Login as {userData?.profile?.display_name}</p>
      <h1>Incident Management</h1>
      <IMDashboard
        dataRegion={dataRegion}
        dataLokasi={dataLokasi}
        dataTahun={dataTahun}
      />
      <br></br>
      <Box component="div" sx={boxStyles} id="tabel">
        {isLoading ? <LoadingSpinner /> : mainContainer}
        {errorMessage && <div className="error">{errorMessage}</div>}
        <iframe
          id="ifmcontentstoprint"
          title="myFrame"
          style={{ height: "0px", width: "0px", position: "absolute" }}
        ></iframe>
      </Box>
    </Box>
  );
};

export default IMReviewVpAsset;
